export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["EMBED_TYPE_UPDATED"] = "embedTypeUpdated";
    ActionTypes["EMBED_SIZE_UPDATED"] = "embedSizeUpdated";
    ActionTypes["VIDEO_EMAIL_EMBED_LOAD_STARTED"] = "videoEmailEmbedLoadStarted";
    ActionTypes["ERROR_DISMISSED"] = "setIsShowingErrorMessage";
    ActionTypes["VIDEO_EMAIL_EMBED_LOAD_SUCCEEDED"] = "videoEmailEmbedLoadSucceeded";
    ActionTypes["VIDEO_EMAIL_EMBED_LOAD_FAILED"] = "videoEmailEmbedLoadFailed";
    ActionTypes["COPY_EMAIL"] = "copyEmail";
})(ActionTypes || (ActionTypes = {}));
/**
 *
 */
export function emailEmbedReducer(state, { type, payload }) {
    switch (type) {
        case ActionTypes.EMBED_TYPE_UPDATED: {
            return {
                ...state,
                embedType: payload,
            };
        }
        case ActionTypes.EMBED_SIZE_UPDATED: {
            return {
                ...state,
                embedSize: payload,
            };
        }
        case ActionTypes.VIDEO_EMAIL_EMBED_LOAD_STARTED: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case ActionTypes.VIDEO_EMAIL_EMBED_LOAD_SUCCEEDED: {
            return {
                ...state,
                isLoading: false,
                emailEmbedCodeToCopy: payload,
            };
        }
        case ActionTypes.VIDEO_EMAIL_EMBED_LOAD_FAILED: {
            return {
                ...state,
                isShowingErrorMessage: true,
                isLoading: false,
            };
        }
        case ActionTypes.ERROR_DISMISSED: {
            return {
                ...state,
                isShowingErrorMessage: false,
            };
        }
        case ActionTypes.COPY_EMAIL: {
            return {
                ...state,
                isShowingSuccessModal: true,
            };
        }
        default:
            return state;
    }
}
